/**
 * nú:d Theme JavaScript
 *
 * @package Nude_Theme
 * @since 1.0.0
 */

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', function () {

		// ============================================
		// Hamburger Menu Toggle
		// ============================================
		const menuTrigger = document.getElementById('menu-trigger');
		const globalNav = document.getElementById('global-nav');

		if (menuTrigger && globalNav) {
			function toggleMenu() {
				const isOpen = document.body.classList.contains('menu-open');

				if (isOpen) {
					// Close menu
					document.body.classList.remove('menu-open');
					menuTrigger.setAttribute('aria-expanded', 'false');
					menuTrigger.setAttribute('aria-label', 'メニューを開く');
					globalNav.setAttribute('aria-hidden', 'true');
					document.body.style.overflow = '';
				} else {
					// Open menu
					document.body.classList.add('menu-open');
					menuTrigger.setAttribute('aria-expanded', 'true');
					menuTrigger.setAttribute('aria-label', 'メニューを閉じる');
					globalNav.setAttribute('aria-hidden', 'false');
					document.body.style.overflow = 'hidden';
				}
			}

			menuTrigger.addEventListener('click', toggleMenu);

			// Keyboard support (Enter / Space)
			menuTrigger.addEventListener('keydown', function (e) {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					toggleMenu();
				}
			});

			// Close on Escape key
			document.addEventListener('keydown', function (e) {
				if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
					toggleMenu();
				}
			});

			// Close menu when clicking a navigation link
			globalNav.querySelectorAll('.nav-links a').forEach(function (link) {
				link.addEventListener('click', function () {
					if (document.body.classList.contains('menu-open')) {
						toggleMenu();
					}
				});
			});
		}

		// ============================================
		// Scroll-triggered fade-in animations
		// ============================================
		const fadeElements = document.querySelectorAll('.nude-fade-in');

		if (fadeElements.length > 0) {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							entry.target.classList.add('visible');
						}
					});
				},
				{
					threshold: 0.1,
					rootMargin: '0px 0px -50px 0px',
				}
			);

			fadeElements.forEach((el) => observer.observe(el));
		}

		// ============================================
		// Header scroll effect
		// ============================================
		const header = document.querySelector('.site-header');
		if (header) {
			window.addEventListener('scroll', function () {
				if (window.scrollY > 100) {
					header.classList.add('scrolled');
				} else {
					header.classList.remove('scrolled');
				}
			});
		}

		// ============================================
		// Ingredients toggle (now a link, no JS needed)
		// ============================================

		// ============================================
		// FAQ Accordion
		// ============================================
		const faqItems = document.querySelectorAll('.faq-item');
		faqItems.forEach(function (item) {
			const question = item.querySelector('.faq-question');
			const answer = item.querySelector('.faq-answer');
			const toggle = item.querySelector('.faq-toggle');

			if (!question || !answer || !toggle) return;

			question.addEventListener('click', function () {
				const isOpen = item.classList.contains('open');

				// Close all other items
				faqItems.forEach(function (otherItem) {
					if (otherItem !== item) {
						otherItem.classList.remove('open');
						var otherAnswer = otherItem.querySelector('.faq-answer');
						var otherToggle = otherItem.querySelector('.faq-toggle');
						if (otherAnswer) otherAnswer.style.maxHeight = null;
						if (otherToggle) otherToggle.textContent = '+';
					}
				});

				// Toggle current item
				if (isOpen) {
					item.classList.remove('open');
					answer.style.maxHeight = null;
					toggle.textContent = '+';
				} else {
					item.classList.add('open');
					answer.style.maxHeight = answer.scrollHeight + 'px';
					toggle.textContent = '\u2212'; // minus sign
				}
			});
		});

		// ============================================
		// FAQ Page Accordion
		// ============================================
		const faqPageItems = document.querySelectorAll('.faq-page-item');
		faqPageItems.forEach(function (item) {
			const question = item.querySelector('.faq-page-question');
			const answer = item.querySelector('.faq-page-answer');
			const toggle = item.querySelector('.faq-toggle');

			if (!question || !answer || !toggle) return;

			question.addEventListener('click', function () {
				const isOpen = item.classList.contains('open');

				// Close all other items in the same category
				var parent = item.closest('.faq-page-list');
				if (parent) {
					parent.querySelectorAll('.faq-page-item').forEach(function (otherItem) {
						if (otherItem !== item) {
							otherItem.classList.remove('open');
							var otherAnswer = otherItem.querySelector('.faq-page-answer');
							var otherToggle = otherItem.querySelector('.faq-toggle');
							var otherQuestion = otherItem.querySelector('.faq-page-question');
							if (otherAnswer) otherAnswer.style.maxHeight = null;
							if (otherToggle) otherToggle.textContent = '+';
							if (otherQuestion) otherQuestion.setAttribute('aria-expanded', 'false');
						}
					});
				}

				// Toggle current item
				if (isOpen) {
					item.classList.remove('open');
					answer.style.maxHeight = null;
					toggle.textContent = '+';
					question.setAttribute('aria-expanded', 'false');
					answer.setAttribute('aria-hidden', 'true');
				} else {
					item.classList.add('open');
					answer.style.maxHeight = answer.scrollHeight + 'px';
					toggle.textContent = '\u2212';
					question.setAttribute('aria-expanded', 'true');
					answer.setAttribute('aria-hidden', 'false');
				}
			});
		});

		// ============================================
		// Back to top
		// ============================================
		const backToTop = document.querySelector('.back-to-top');
		if (backToTop) {
			backToTop.addEventListener('click', function (e) {
				e.preventDefault();
				window.scrollTo({ top: 0, behavior: 'smooth' });
			});
		}

		// ============================================
		// Footer nav scroll to section
		// ============================================
		const footerNavLinks = document.querySelectorAll(
			'.footer-nav-list a[data-section]'
		);
		footerNavLinks.forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				var sectionClass = this.getAttribute('data-section');
				var target = document.querySelector('.' + sectionClass);
				if (target) {
					target.scrollIntoView({ behavior: 'smooth' });
				}
			});
		});

		// ============================================
		// Footer accordion (mobile)
		// ============================================
		const footerToggles = document.querySelectorAll('.footer-nav-toggle');
		footerToggles.forEach(function (toggle) {
			toggle.addEventListener('click', function () {
				if (window.innerWidth <= 768) {
					var col = this.closest('.footer-nav-col');
					var isOpen = col.classList.contains('is-open');

					document
						.querySelectorAll('.footer-nav-col')
						.forEach(function (c) {
							c.classList.remove('is-open');
						});
					document
						.querySelectorAll('.footer-nav-toggle')
						.forEach(function (t) {
							t.setAttribute('aria-expanded', 'false');
						});

					if (!isOpen) {
						col.classList.add('is-open');
						this.setAttribute('aria-expanded', 'true');
					}
				}
			});
		});
		// ============================================
		// Table of Contents auto-generation (from .single-content headings)
		// ============================================
		(function () {
			var content = document.querySelector('.single-content');
			if (!content || document.querySelector('.toc-container')) return;

			var headings = content.querySelectorAll('h2, h3');
			if (headings.length < 2) return;

			var listItems = '';
			headings.forEach(function (h, i) {
				var id = h.id || 'section-' + i;
				h.id = id;
				var sub = h.tagName.toLowerCase() === 'h3' ? ' class="toc-sub"' : '';
				var text = h.textContent.trim();
				listItems +=
					'<li' + sub + '><a href="#' + id + '">' +
					text.replace(/[&<>]/g, function (c) {
						return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c];
					}) +
					'</a></li>';
			});

			var toc = document.createElement('nav');
			toc.className = 'toc-container nude-fade-in';
			toc.setAttribute('aria-label', '目次');
			toc.innerHTML =
				'<div class="toc-header"><span class="toc-label">目次</span></div>' +
				'<div class="toc-list-wrapper"><ol class="toc-list">' + listItems + '</ol></div>' +
				'<button class="toc-toggle" type="button" aria-expanded="false">' +
				'<span class="toc-toggle-icon">+</span>' +
				'<span class="toc-toggle-text">すべて表示</span>' +
				'</button>';

			var firstH2 = content.querySelector('h2');
			if (firstH2) {
				content.insertBefore(toc, firstH2);
			} else {
				content.insertBefore(toc, content.firstChild);
			}

			// The global IntersectionObserver only tracks .nude-fade-in elements
			// present at init time. Since this TOC is injected later, trigger its
			// fade-in manually so it doesn't stay stuck at opacity: 0.
			requestAnimationFrame(function () {
				toc.classList.add('visible');
			});
		})();

		// ============================================
		// Table of Contents toggle (collapse/expand)
		// ============================================
		var tocToggle = document.querySelector('.toc-toggle');
		var tocContainer = document.querySelector('.toc-container');
		if (tocToggle && tocContainer) {
			var tocText = tocToggle.querySelector('.toc-toggle-text');
			var tocIcon = tocToggle.querySelector('.toc-toggle-icon');
			var tocWrapper = tocContainer.querySelector('.toc-list-wrapper');

			// Hide toggle if list is short enough
			if (tocWrapper && tocWrapper.scrollHeight <= 180) {
				tocToggle.style.display = 'none';
				tocContainer.classList.add('toc-expanded');
			}

			tocToggle.addEventListener('click', function (e) {
				e.preventDefault();
				var isExpanded = tocContainer.classList.contains('toc-expanded');
				if (isExpanded) {
					tocContainer.classList.remove('toc-expanded');
					this.setAttribute('aria-expanded', 'false');
					if (tocText) tocText.textContent = 'すべて表示';
					if (tocIcon) tocIcon.textContent = '+';
				} else {
					tocContainer.classList.add('toc-expanded');
					this.setAttribute('aria-expanded', 'true');
					if (tocText) tocText.textContent = '閉じる';
					if (tocIcon) tocIcon.textContent = '+';
				}
			});
		}

		// ============================================
		// Smooth blob animation (section numbers + texture video)
		// ============================================
		(function () {
			var blobData = [];

			// Small blobs: all section-number elements (subtle movement)
			document.querySelectorAll('.serum-section-number, .brand-section-number, .howtouse-section-number, .ingredients-section-number').forEach(function (el, i) {
				blobData.push({
					el: el,
					offset: i * 1.7,
					visible: false,
					// Small element: subtle amplitude, moderate speed
					amp1: 6, amp2: 3, speed: 1.0, scaleAmp: 0.03, rotAmp: 1.5, center: 50
				});
			});

			// Large blob: serum-texture-video (bigger, slower organic motion)
			document.querySelectorAll('.serum-texture-video').forEach(function (el, i) {
				blobData.push({
					el: el,
					offset: 5.3 + i * 2.1,
					visible: false,
					// Large element: wider amplitude, slower speed, no scale/rotate
					amp1: 10, amp2: 5, speed: 0.5, scaleAmp: 0, rotAmp: 0, center: 55
				});
			});

			if (!blobData.length) return;

			// IntersectionObserver: only animate when visible
			var blobObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					var idx = blobData.findIndex(function (b) { return b.el === entry.target; });
					if (idx !== -1) blobData[idx].visible = entry.isIntersecting;
				});
			}, { threshold: 0, rootMargin: '100px' });

			blobData.forEach(function (b) { blobObserver.observe(b.el); });

			var running = false;

			function animateBlobs(time) {
				var t = time * 0.001; // seconds
				var anyVisible = false;

				for (var i = 0; i < blobData.length; i++) {
					if (!blobData[i].visible) continue;
					anyVisible = true;

					var d = blobData[i];
					var o = d.offset;
					var s = d.speed;
					var a1 = d.amp1;
					var a2 = d.amp2;
					var ct = d.center;

					// Multiple sine waves at different frequencies for organic motion
					var a = ct + a1 * Math.sin(t * 0.7 * s + o) + a2 * Math.sin(t * 1.3 * s + o * 0.5);
					var b = ct - a1 * Math.sin(t * 0.7 * s + o) - a2 * Math.sin(t * 1.3 * s + o * 0.5);
					var c = ct + (a1 - 1) * Math.sin(t * 0.9 * s + o + 1) + (a2 - 1) * Math.sin(t * 1.7 * s + o * 0.8);
					var e = ct - (a1 - 1) * Math.sin(t * 0.9 * s + o + 1) - (a2 - 1) * Math.sin(t * 1.7 * s + o * 0.8);
					var f = ct + (a1 - 2) * Math.sin(t * 1.1 * s + o + 2) + a2 * Math.sin(t * 0.6 * s + o * 1.2);
					var g = ct - (a1 - 2) * Math.sin(t * 1.1 * s + o + 2) - a2 * Math.sin(t * 0.6 * s + o * 1.2);
					var h = ct + (a1 - 1) * Math.sin(t * 0.8 * s + o + 3) + (a2 - 1) * Math.sin(t * 1.5 * s + o * 0.3);
					var j = ct - (a1 - 1) * Math.sin(t * 0.8 * s + o + 3) - (a2 - 1) * Math.sin(t * 1.5 * s + o * 0.3);

					d.el.style.borderRadius =
						a.toFixed(1) + '% ' + b.toFixed(1) + '% ' +
						c.toFixed(1) + '% ' + e.toFixed(1) + '% / ' +
						f.toFixed(1) + '% ' + g.toFixed(1) + '% ' +
						h.toFixed(1) + '% ' + j.toFixed(1) + '%';

					if (d.scaleAmp > 0 || d.rotAmp > 0) {
						var sc = 1 + d.scaleAmp * Math.sin(t * 0.5 * s + o);
						var rot = d.rotAmp * Math.sin(t * 0.4 * s + o * 0.7);
						d.el.style.transform =
							'translateZ(0) scale(' + sc.toFixed(4) + ') rotate(' + rot.toFixed(2) + 'deg)';
					}
				}

				if (anyVisible) {
					requestAnimationFrame(animateBlobs);
				} else {
					running = false;
				}
			}

			// Start/stop loop based on visibility
			setInterval(function () {
				var anyVisible = blobData.some(function (b) { return b.visible; });
				if (anyVisible && !running) {
					running = true;
					requestAnimationFrame(animateBlobs);
				}
			}, 500);

			// Start immediately if already visible
			requestAnimationFrame(function () {
				var anyVisible = blobData.some(function (b) { return b.visible; });
				if (anyVisible) {
					running = true;
					requestAnimationFrame(animateBlobs);
				}
			});
		})();

		// ============================================
		// Smooth scroll for TOC links
		// ============================================
		document.querySelectorAll('.toc-list a').forEach(function (link) {
			link.addEventListener('click', function (e) {
				var targetId = this.getAttribute('href');
				if (targetId && targetId.startsWith('#')) {
					var target = document.querySelector(targetId);
					if (target) {
						e.preventDefault();
						var headerHeight = 80;
						var targetPos =
							target.getBoundingClientRect().top +
							window.pageYOffset -
							headerHeight;
						window.scrollTo({
							top: targetPos,
							behavior: 'smooth',
						});
					}
				}
			});
		});

		// ============================================
		// Share: Copy link to clipboard
		// ============================================
		function nudeCopyToClipboard(text) {
			// navigator.clipboard は HTTPS / localhost のみ対応
			if (navigator.clipboard && navigator.clipboard.writeText) {
				return navigator.clipboard.writeText(text);
			}
			// フォールバック: execCommand('copy') — HTTP 環境でも動作
			return new Promise(function (resolve, reject) {
				var textarea = document.createElement('textarea');
				textarea.value = text;
				textarea.style.position = 'fixed';
				textarea.style.left = '-9999px';
				textarea.style.top = '-9999px';
				textarea.style.opacity = '0';
				document.body.appendChild(textarea);
				textarea.focus();
				textarea.select();
				try {
					var ok = document.execCommand('copy');
					document.body.removeChild(textarea);
					ok ? resolve() : reject(new Error('copy failed'));
				} catch (err) {
					document.body.removeChild(textarea);
					reject(err);
				}
			});
		}

		document.querySelectorAll('.share-copy').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var url = this.getAttribute('data-url');
				if (!url) return;

				var iconEl = this.querySelector('.share-copy-icon');
				var checkEl = this.querySelector('.share-copy-check');
				var self = this;

				nudeCopyToClipboard(url).then(function () {
					self.classList.add('is-copied');
					if (iconEl) iconEl.style.display = 'none';
					if (checkEl) checkEl.style.display = 'block';

					setTimeout(function () {
						self.classList.remove('is-copied');
						if (iconEl) iconEl.style.display = 'block';
						if (checkEl) checkEl.style.display = 'none';
					}, 2000);
				});
			});
		});

		/* ==========================================
		   Ingredients Video
		   - PC: ホバー中のみ再生
		   - モバイル: 表示時に一度だけ再生
		   ========================================== */
		(function () {
			var cards = document.querySelectorAll('.nude-ingredient-item');
			if (!cards.length) return;

			var isDesktopHover =
				window.matchMedia &&
				window.matchMedia('(hover: hover) and (pointer: fine)').matches;

			if (isDesktopHover) {
				cards.forEach(function (card) {
					var video = card.querySelector('.ingredient-video');
					if (!video) return;

					video.loop = true;

					var playOnHover = function () {
						card.classList.add('is-playing');
						video.currentTime = 0;
						video.play().catch(function () {
							// 自動再生がブロックされた場合は無視
						});
					};

					var pauseOnLeave = function () {
						card.classList.remove('is-playing');
						video.pause();
						video.currentTime = 0;
					};

					card.addEventListener('mouseenter', playOnHover);
					card.addEventListener('mouseleave', pauseOnLeave);
				});
				return;
			}

			// スマホ/タブレット: 画面内に入ったカードの動画を一度だけ再生
			var playedSet = new WeakSet();

			function playOnce(card) {
				var video = card.querySelector('.ingredient-video');
				if (!video || playedSet.has(card)) return;

				playedSet.add(card);
				video.loop = false;
				card.classList.add('is-playing');
				video.currentTime = 0;

				video.play().catch(function () {
					// 端末ポリシーでブロックされた場合は無視
				});

				video.addEventListener(
					'ended',
					function () {
						card.classList.remove('is-playing');
					},
					{ once: true }
				);
			}

			if ('IntersectionObserver' in window) {
				var observer = new IntersectionObserver(
					function (entries, io) {
						entries.forEach(function (entry) {
							if (!entry.isIntersecting) return;
							playOnce(entry.target);
							io.unobserve(entry.target);
						});
					},
					{ threshold: 0.45 }
				);

				cards.forEach(function (card) {
					observer.observe(card);
				});
			} else {
				cards.forEach(function (card) {
					playOnce(card);
				});
			}
		})();

		/* ==========================================
		   Scene Video – 画面に入ったら自動再生 & ループ
		   ========================================== */
		(function () {
			var videos = document.querySelectorAll('.scene-video, .serum-concept-video');
			if (!videos.length) return;

			if ('IntersectionObserver' in window) {
				var observer = new IntersectionObserver(function (entries) {
					entries.forEach(function (entry) {
						var video = entry.target;
						if (entry.isIntersecting) {
							video.play().catch(function () {
								// 自動再生がブロックされた場合は無視
							});
						} else {
							video.pause();
							video.currentTime = 0;
						}
					});
				}, { threshold: 0.25 });

				videos.forEach(function (video) {
					observer.observe(video);
				});
			} else {
				// IntersectionObserver 非対応ブラウザ: すべて即再生
				videos.forEach(function (video) {
					video.play().catch(function () {});
				});
			}
		})();

		// ============================================
		// Product plan cards (単品 / まとめ買い / 定期便)
		// ============================================
		(function initSerumPlanCards() {
			var cards = document.querySelectorAll('.serum-plan-card[data-plan]');
			var form = document.getElementById('serum-product-form');
			if (!cards.length || !form) return;

			var qtyInput = form.querySelector('#serum-qty');
			var planInput = form.querySelector('#serum-selling-plan-input');
			var buyBtnLabel = form.querySelector('.serum-buy-btn-label');
			var subscriptionNotice = document.getElementById('serum-subscription-notice');
			var labels = {
				single: '単品で購入する',
				bundle2: '2本セットで購入する',
				subscription: '定期購入する'
			};

			function setActive(card) {
				cards.forEach(function (c) {
					var active = c === card;
					c.classList.toggle('is-active', active);
					c.setAttribute('aria-pressed', active ? 'true' : 'false');
				});
			}

			function updateSubscriptionNotice(isSubscription) {
				if (!subscriptionNotice) return;
				subscriptionNotice.hidden = !isSubscription;
				subscriptionNotice.setAttribute('aria-hidden', isSubscription ? 'false' : 'true');
			}

			function applyPlan(card) {
				var plan = card.getAttribute('data-plan');
				var qty = card.getAttribute('data-qty') || '1';
				if (qtyInput) qtyInput.value = qty;

				if (plan === 'subscription' && planInput) {
					var sellingPlanId = card.getAttribute('data-selling-plan') || '';
					planInput.value = sellingPlanId;
					planInput.disabled = sellingPlanId === '';
				} else if (planInput) {
					planInput.value = '';
					planInput.disabled = true;
				}

				if (buyBtnLabel) {
					buyBtnLabel.textContent = labels[plan] || labels.single;
				}

				updateSubscriptionNotice(plan === 'subscription');
			}

			cards.forEach(function (card) {
				card.addEventListener('click', function () {
					setActive(card);
					applyPlan(card);
				});
			});

			var defaultCard = document.querySelector('.serum-plan-card.is-active[data-plan]') || cards[0];
			if (defaultCard) {
				setActive(defaultCard);
				applyPlan(defaultCard);
			}
		})();
	});
})();
